import { endpoint,mappable } from '../decorators';
import { BaseViewModel } from './base-view-model';
import { CorrespondenceViewModel } from './correspondence-view-model';
import { DocumentViewModel } from './document-view-model';

@endpoint('CorrespondenceDocument')
export class CorrespondenceDocumentViewModel extends BaseViewModel {
  public CorrespondenceId = 0;
  public DocumentId = 0;

  @mappable('DocumentViewModel')
  public Document: DocumentViewModel = null;

  @mappable('CorrespondenceViewModel')
  public Correspondence: CorrespondenceViewModel = null;
}
